const publicUrl = process.env.PUBLIC_URL || '';

export const brandLogo = {
  alt: "Al's-Ops LLC logo",
  src: `${publicUrl}/brand/logo-256.png`,
  srcSet: [
    `${publicUrl}/brand/logo-64.png 64w`,
    `${publicUrl}/brand/logo-128.png 128w`,
    `${publicUrl}/brand/logo-256.png 256w`,
    `${publicUrl}/brand/logo-512.png 512w`,
  ].join(', '),
  headerSizes: '(max-width: 768px) 44px, 52px',
  footerSizes: '(max-width: 768px) 44px, 52px',
  loadingSizes: '(max-width: 768px) 180px, 260px',
};
